// extracted by mini-css-extract-plugin
export default {"container":"matchScorePrintPage__container__V4bJ2"};